/**
 *  Component: Current Connections Section
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const CurrentConnectionsSection = ({ connection }) => (
  <FormContainer>
    <FormHeading>
      <Icon rotate>
        <LinkIcon />
      </Icon>
      Current connections
    </FormHeading>
    <Separator />
    <BodyContainer>
      <StyledGrid container>
        <Grid xs={4}>
          <StyledTypography color="#333">{connection.displayName}</StyledTypography>
        </Grid>
        <Grid>
          <StyledTypography color="#666">{connection.workspaceUrl}</StyledTypography>
        </Grid>
      </StyledGrid>
    </BodyContainer>
  </FormContainer>
);

const StyledGrid = styled(Grid)`
  background: #eaeaea;
  padding: 10px;
  margin-top: 0.6rem;
  margin-bottom: -0.6rem;
`;

export default CurrentConnectionsSection;
